import { Check, LockKeyhole } from "lucide-react";
import { home } from "../content/home";

const { label, headline, points, links } = home.trust;

// The page's one dark band, full width with straight edges, so privacy stands apart from everything else.
// The blue steps up to brand-300 to read on charcoal.
export function TrustSection() {
  return (
    <section id="trust" aria-label={label} data-nav-dark className="scroll-mt-20 bg-char px-4 py-24 sm:px-6 lg:py-32">
      <div className="mx-auto max-w-6xl">
        <div className="grid gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16">
          <div>
            <h2 className="font-serif text-[clamp(2.25rem,4.5vw,3.5rem)] font-medium leading-[1.02] tracking-[-0.015em] text-paper-white">
              {headline.line1}
              <br />
              <em className="text-brand-300">{headline.line2}</em>
            </h2>
            <ul className="mt-8 space-y-2 font-sans text-base font-semibold">
              {links.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="rounded text-paper-white underline decoration-paper-white/30 underline-offset-[6px] transition-colors hover:decoration-paper-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-300"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
            {/* A large, quiet lock in the empty space under the links (desktop only). */}
            <div data-testid="trust-lock" aria-hidden="true" className="mt-14 hidden lg:block">
              <LockKeyhole className="h-36 w-36 text-brand-300/80" strokeWidth={1} />
            </div>
          </div>

          <ul className="divide-y divide-paper-white/15">
            {points.map((point) => (
              <li key={point.title} className="flex gap-4 py-4 first:pt-0 last:pb-0">
                <span className="mt-1 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand-500">
                  <Check className="h-3.5 w-3.5 text-white" strokeWidth={3} aria-hidden="true" />
                </span>
                <div>
                  <div className="flex flex-wrap items-center gap-x-2.5 gap-y-1">
                    <h3 className="font-serif text-[22px] leading-tight text-paper-white">{point.title}</h3>
                    {"tag" in point && (
                      <span className="rounded-full border border-brand-300/60 px-2.5 py-0.5 font-sans text-xs font-semibold text-brand-300">
                        {point.tag}
                      </span>
                    )}
                  </div>
                  <p className="mt-1 font-sans text-base leading-relaxed text-paper-white/70">{point.body}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>

      </div>
    </section>
  );
}
